import Failure from "../../../core/Failure";
import HttpClient from "../../../core/HttpClient";
import { ContactHistoryType, contactHistoryTypeAsInfo } from "@leedpulse-monorepo/enums";
import getScenarioById from "../scenarios/getScenarioById";
import { Authentication } from "@leedpulse-monorepo/classes";
import { IContact } from "@leedpulse-monorepo/interfaces";

async function updateContact(initialContact: IContact, updatedContact: IContact, auth: Authentication): Promise<void> {
  try {
    if (!updatedContact || updatedContact.contact.firstname === '' ||
      updatedContact.contact.lastname === '' ||
      updatedContact.contact.phone === '') {
      throw new Error('La fiche du contact est incomplète (prénom, nom ou téléphone manquant)');
    }

    // Only the edited fields: the rest of the form is a copy that may be stale by now
    const patch: Record<string, unknown> = {};
    Object.entries(updatedContact.contact).forEach(([field, value]) => {
      if (value !== initialContact.contact[field as keyof IContact['contact']]) patch[`contact.${field}`] = value;
    });

    if (Object.keys(patch).length === 0) return;

    if (updatedContact.contact.prospect_category !== initialContact.contact.prospect_category) {

      const oScenario = await getScenarioById(updatedContact.contact.prospect_category);

      // Whole copy plus the event: the API only adds the new ones, an older API replaced the array
      patch.history = [...(initialContact.history ?? []), {
        id_source: updatedContact.id,
        timestamp: new Date().getTime(),
        type: ContactHistoryType.scenarioupdate,
        info: contactHistoryTypeAsInfo(ContactHistoryType.scenarioupdate, oScenario?.name || '')
      }];
    }

    // Goes through the API and not straight to Firestore: the phone unicity is checked
    // server-side, on the normalized number. The API also stamps `updated` and pushes
    // the `updatemanualinfo` history event.
    await HttpClient.put(
      '/contact',
      { id: updatedContact.id, ...patch },
      auth.token,
      {
        'x-api-key': updatedContact.id_api_key,
      }
    );

    return;
  } catch (e) {
    console.log("error: ", e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new UpdateContactFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new UpdateContactFailure(e.message);
    }
  }
}

export class UpdateContactFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default updateContact;
